module.exports = __webpack_public_path__ + "static/media/siddharth-wonderla-trip-01.821f0669.png";